import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 75px; 
      height: 85px;
    }`
  }
`
const color = "#707070"

const GaugeIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG version="1.0" xmlns="http://www.w3.org/2000/svg" width="100" height="100" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 200.000000 200.000000" preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path 
          className="fillHoverSVG"
          d="M881 1350 c-367 -58 -651 -362 -678 -727 l-6 -73 122 0 c119 0 121 0 121 23 1 49 32 166 60 223 144 294 508 404 783 237 l58 -35 86 74 c48 41 88 79 91 86 9 29 -183 137 -308 172 -85 23 -247 33 -329 20z"
          fill={color}
        />
        <path 
          className="fillHoverSVG"
          d="M1350 970 c-236 -200 -340 -282 -363 -287 -47 -9 -66 -21 -87 -56 -25 -41 -25 -94 -1 -131 26 -40 57 -55 110 -56 36 0 49 6 76 33 20 20 36 48 40 69 7 35 93 142 502 621 41 48 70 87 64 87 -5 0 -159 -126 -341 -280z"
          fill={color}
        />
        <path 
          className="fillHoverSVG"
          d="M1516 989 l-77 -91 21 -32 c52 -77 99 -216 100 -293 0 -23 2 -23 121 -23 l122 0 -6 73 c-7 99 -31 187 -77 282 -38 79 -103 175 -119 175 -4 0 -43 -41 -85 -91z" 
          fill={color}
        />
      </g>
    </SVG>
  </IconContainer>
)

export default GaugeIcon